import { render } from "./GroupSelectionLandingPage.vue?vue&type=template&id=9a3e9270&scoped=true&ts=true"
import script from "./GroupSelectionLandingPage.vue?vue&type=script&lang=ts"
export * from "./GroupSelectionLandingPage.vue?vue&type=script&lang=ts"

import "./GroupSelectionLandingPage.vue?vue&type=style&index=0&id=9a3e9270&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a3e9270"]])

export default __exports__